import React from 'react';
import PropTypes from 'prop-types';

import { Card, CardSection } from 'components/Card';
import Message from 'components/Message';

import { bem } from 'helpers/class-name';

import CopyRecoveryCodesStep from './CopyRecoveryCodesStep';

import { messages } from './MFASetupModal.messages';
import './MFASetupModal.scss';

const { block, element } = bem('mfa-setup-modal');

export const MFARecoveryCodesModal = ({ recoveryCodes }) => {
  return (
    <Card className={block()}>
      <CardSection flush className={element('header')}>
        <Message as="h1" message={messages.recoveryCodesTitle} />
      </CardSection>

      <CopyRecoveryCodesStep recoveryCodes={recoveryCodes} />
    </Card>
  );
};

MFARecoveryCodesModal.propTypes = {
  recoveryCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
};
